import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Table } from 'react-bootstrap';

class VersionDiffModal extends Component {
  getDiff = (oldVersion, newVersion) => {
    if (!oldVersion || !newVersion) return [];
    
    const diffs = [];
    
    // Compare basic fields
    const fields = [
      'product_name', 'sku_code', 'style', 'size', 'base_price_vnd', 
      'default_quantity', 'friendly_version', 'status'
    ];

    fields.forEach(field => {
      if (oldVersion[field] !== newVersion[field]) {
        diffs.push({
          field,
          oldValue: oldVersion[field],
          newValue: newVersion[field]
        });
      }
    });

    // Compare properties
    if (oldVersion.properties || newVersion.properties) {
      const propertyFields = ['material', 'color', 'note', 'length_mm', 'width_mm', 'height_mm', 'weight_g'];
      propertyFields.forEach(field => {
        const oldValue = oldVersion.properties?.[field];
        const newValue = newVersion.properties?.[field];
        if (oldValue !== newValue) {
          diffs.push({
            field: `properties.${field}`,
            oldValue,
            newValue
          });
        }
      });
    }

    // Compare images
    const oldImages = oldVersion.images || [];
    const newImages = newVersion.images || [];
    
    // Check for removed images
    oldImages.forEach((oldImage, index) => {
      const newImage = newImages[index];
      if (!newImage) {
        diffs.push({
          field: `images[${index}]`,
          oldValue: `Image: ${oldImage.image_link}\nAlt: ${oldImage.alt_text}`,
          newValue: 'Removed'
        });
      } else if (oldImage.image_link !== newImage.image_link || oldImage.alt_text !== newImage.alt_text) {
        diffs.push({
          field: `images[${index}]`,
          oldValue: `Image: ${oldImage.image_link}\nAlt: ${oldImage.alt_text}`,
          newValue: `Image: ${newImage.image_link}\nAlt: ${newImage.alt_text}`
        });
      }
    });

    // Check for added images
    newImages.forEach((newImage, index) => {
      if (index >= oldImages.length) {
        diffs.push({
          field: `images[${index}]`,
          oldValue: 'Added',
          newValue: `Image: ${newImage.image_link}\nAlt: ${newImage.alt_text}`
        });
      }
    });

    return diffs;
  };

  render() {
    const { isOpen, toggle, oldVersion, newVersion } = this.props;
    const diffs = this.getDiff(oldVersion, newVersion);

    return (
      <Modal isOpen={isOpen} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>
          Version Changes: {oldVersion?.version} → {newVersion?.version}
          {newVersion?.updated_by && (
            <span className="ms-2" style={{ fontWeight: 400, fontSize: 16 }}>
              (By: {newVersion.updated_by})
            </span>
          )}
        </ModalHeader>
        <ModalBody>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Field</th>
                <th>Old Value</th>
                <th>New Value</th>
              </tr>
            </thead>
            <tbody>
              {diffs.map((diff, index) => (
                <tr key={index}>
                  <td>{diff.field}</td>
                  <td className="text-danger">
                    {diff.oldValue !== undefined ? diff.oldValue : '-'}
                  </td>
                  <td className="text-success">
                    {diff.newValue !== undefined ? diff.newValue : '-'}
                  </td>
                </tr>
              ))}
              {diffs.length === 0 && (
                <tr>
                  <td colSpan="3" className="text-center">No changes found</td>
                </tr>
              )}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>
    );
  }
}

export default VersionDiffModal; 